import interceptor from './interceptor';

const getAllPitchDecks = () => {
  const request = interceptor.apiWithAuth.get('/pitchdeckstatus/get-all/');
  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const getPitchDeckStatusByID = (pitchDeckStatusId: string) => {
  const request = interceptor.apiWithAuth.get(
    '/get-pitchdeckstatus-by-id/' + pitchDeckStatusId
  );
  return request
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

//get all PitchDeck Statuses and select the one that matches the state passed in as a string parameter
const getPitchDeckStatusByName = (state: string) => {
  const request = interceptor.apiWithAuth.get(
    '/pitchdeckstatus/get-pitchdeckstatus-by-name/' + state
  );
  return request
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};
const pitchDeckStatusService = {
  getAllPitchDecks,
  getPitchDeckStatusByID,
  getPitchDeckStatusByName
};
export default pitchDeckStatusService;
